module.exports = __webpack_public_path__ + "img/header.b2ca0ea6.png";